<template>
  <div>
    <ul class="nav nav-tabs" fill>
      <li class="nav-item" v-if="checkClaim(CAN_ACCESS_ACTIVE_REQS)">
        <router-link :to="requirementsLink" class="nav-link">
          <i class="fa fa-list-ol mr-1"/>Requirements
        </router-link>
      </li>
      <li class="nav-item" v-if="checkClaim(CAN_ACCESS_SOURCING_CENTER)">
        <router-link :to="rfpLink" class="nav-link">
          <i class="fa fa-handshake-o mr-1"/>Sourcing
        </router-link>
      </li>
      <li class="nav-item" v-if="checkClaim(CAN_ACCESS_QUOTES)"> 
        <router-link :to="quotesLink" class="nav-link">
          <i class="fa fa-quote-left mr-1"/>Quotes
        </router-link>
      </li>
      <li class="nav-item" v-if="checkClaim(CAN_ACCESS_SALES_ORDERS)">
        <router-link :to="salesOrderLink" class="nav-link">
          <i class="fa fa-sellsy mr-1"/>Sales Orders
        </router-link>
      </li>
      <li class="nav-item" v-if="checkClaim(CAN_ACCESS_PROFORMA)">
        <router-link :to="proformaInvoicesLink" class="nav-link">
          <i class="fa fa-newspaper-o mr-1"/>Proforma 
        </router-link>
      </li>
      <li class="nav-item" v-if="checkClaim(CAN_ACCESS_VIEW_POS)">
        <router-link :to="purchaseOrderLink" class="nav-link">
          <i class="fa fa-money mr-1"/>Purchase Orders
        </router-link>
      </li>
      <li class="nav-item" v-if="checkClaim(CAN_ACCESS_WORK_ORDER)">
        <router-link :to="serviceOrderLink" class="nav-link">
          <i class="fa fa-credit-card mr-1"/>Work Orders
        </router-link>
      </li>
      <li class="nav-item" v-if="checkClaim(CAN_ACCESS_INVOICES)">
        <router-link :to="invoicesLink" class="nav-link">
          <i class="fa fa-file-text-o mr-1"/>Invoices
        </router-link>
      </li>
      <li class="nav-item" v-if="checkClaim(CAN_ACCESS_RMAS)">
        <router-link :to="customerRmaLink" class="nav-link">
          <i class="fa fa-user-md mr-1"/>Customer RMA
        </router-link>
      </li>
      <li class="nav-item" v-if="checkClaim(CAN_ACCESS_VENDOR_RETURNS)">
        <router-link :to="vendorRmaLink" class="nav-link">
          <i class="fa fa-user-secret mr-1"/>Vendor RMAs
        </router-link>
      </li>
    </ul>
    <router-view></router-view>
  </div>
</template>
<script>
  import { mapGetters, mapMutations } from 'vuex';

  export default {
    metaInfo: () => ({
      title: 'New Erp',
    }),
    data() {
      return {};
    },
    computed: {
      ...mapGetters('salesCenter', ['lastOpenedTab',
        'requirementsLink',
        'rfpLink',
        'quotesLink',
        'salesOrderLink',
        'purchaseOrderLink',
        'invoicesLink',
        'proformaInvoicesLink',
        'serviceOrderLink',
        'customerRmaLink',
        'vendorRmaLink']),
    },
    methods: {
      ...mapMutations('salesCenter', ['setItem']),
    },
    watch: {},
    mounted() {
      if (!this.lastOpenedTab) {
        this.setItem({ resource: 'requirementsLink', payload: this.requirementsLink });
        this.setItem({ resource: 'lastOpenedTab', payload: this.requirementsLink });
      }
      if (this.$route.meta.controlLink) {
        this.setItem({ resource: this.$route.meta.controlLink, payload: this.$route.fullPath });
        this.setItem({ resource: 'lastOpenedTab', payload: this.$route.fullPath });
      }
    },
  };
</script>

<style scoped>
.new-offer-button {
  right: 10px;
  position: absolute;
  top: 4px;
}
</style>
